export default "__VITE_ASSET__2cf7dd72__"